/*eslint-disable */

import { buttonAction_s } from "../../components/Snowplow/config2"
import {
  LOCAL_ACTIVE_ROL,
  LOCAL_COMPANY_ID,
  LOCAL_COMPANY_NAME,
  LOCAL_FIRST_NAME,
  LOCAL_LAST_NAME,
  LOCAL_USER_EMAIL,
  LOCAL_USER_ID,
  LOCAL_USER_ROLES_TEXT,
} from "../storage"

export function startWoopra() {
  ;(function() {
    let t,
      i,
      e,
      n = window,
      o = document,
      a = arguments,
      s = "script",
      r = [
        "config",
        "track",
        "identify",
        "visit",
        "push",
        "call",
        "trackForm",
        "trackClick",
      ],
      c = function() {
        var t,
          i = this
        for (i._e = [], t = 0; r.length > t; t++)
          (function(t) {
            i[t] = function() {
              return (
                i._e.push([t].concat(Array.prototype.slice.call(arguments, 0))),
                i
              )
            }
          })(r[t])
      }
    for (n._w = n._w || {}, t = 0; a.length > t; t++)
      n._w[a[t]] = n[a[t]] = n[a[t]] || new c()
    ;(i = o.createElement(s)),
      (i.async = 1),
      (i.src = "//static.woopra.com/js/w.js"),
      (e = o.getElementsByTagName(s)[0]),
      e.parentNode.insertBefore(i, e)
  })("woopra")

  woopra.config({
    domain: process.env.WOOPRA_APP_URL,
  })

  woopra.track()
}

export const identifyUserWoopra = () => {
  const someData = {
    name: `${LOCAL_FIRST_NAME()} ${LOCAL_LAST_NAME()}`,
    company: LOCAL_COMPANY_NAME(),
    email: LOCAL_USER_EMAIL(),
    id_company: LOCAL_COMPANY_ID(),
    id_user: LOCAL_USER_ID(),
    user_roles: LOCAL_USER_ROLES_TEXT(),
  }
  return someData
}

const getRole = (id) => {
  if (+id === 1 || +id === 2) return "Administrador"
  if (+id === 3 || +id === 4) return "Administrador Mandu"
  if (+id === 5) return "Embajador"
  if (+id === 6) return "Lider"
}

export const woopraTrack = (action, obj = {}) => {
  let roleObj = {
    role: getRole(LOCAL_ACTIVE_ROL()),
    company: LOCAL_COMPANY_NAME(),
  }
 //snowplow
 let data_button = {
  category: (window.location.hash)? window.location.hash: window.location.pathname,
  action: action,
  label:  `Click ${action}`,
  property: "button",
  value: LOCAL_USER_ID(),
}
buttonAction_s(data_button);
  // const newObj = { ...roleObj, ...obj }
  // woopra.identify(identifyUserWoopra()).track(action, newObj)
}

export const woopraTrackPageView = () => {
  // woopra.identify(identifyUserWoopra()).track()
}
  
